const serverNotAvailable = {
    title: 'Идут технические работы',
    description:
        'Ввиду избежания ошибок, функции <b>проведения платежей</b>, <b>подписания договоров</b> и <b>отправления рассылок</b> не работают. Приносим извинения за неудобства',
    buttonText: 'Понятно',
} as const;

export default serverNotAvailable;
